import React from 'react'
import { Icon, SemanticICONS } from 'semantic-ui-react'
import { StyledFormSection } from './style'

interface Props {
  header: string
  headerIcon: SemanticICONS
  children: React.ReactNode
  id?: string
}

const FormSection: React.FC<Props> = (props) => {
  const { header, headerIcon, children, id } = props

  return <StyledFormSection id={id}>
    <div className='section-header'>
      <Icon name={headerIcon} />
      <span className='section-title'>{header}</span>
    </div>
    <div className='section-content'>
      {children}
    </div>
  </StyledFormSection>
}

export default FormSection
